export default {
  "adsUserPushRecord.loadingFailedRecords": "Obteniendo registros fallidos…",
  "adsUserPushRecord.batchRetryButtonText": "Reintentar en lote los registros fallidos (total {count})",
  "adsUserPushRecord.noFailedRecordsToRetry": "No hay registros fallidos para reintentar",
  'adsUserPushRecord.title': 'Registros de Notificaciones',
  'adsUserPushRecord.memberId': 'ID del Miembro',
  'adsUserPushRecord.memberAccount': 'Cuenta del Miembro',
  'adsUserPushRecord.adsName': 'Nombre de Configuración de Atribución',
  'adsUserPushRecord.agentAccount': 'Cuenta del Agente',
  'adsUserPushRecord.adsType': 'Canal de Atribución',
  'adsUserPushRecord.status': 'Estado',
  'adsUserPushRecord.eventName': 'Nombre del Evento',
  'adsUserPushRecord.dateRange': 'Rango de Fechas',
  'adsUserPushRecord.search': 'Buscar',
  'adsUserPushRecord.reset': 'Restablecer',
  'adsUserPushRecord.userId': 'ID del Usuario',
  'adsUserPushRecord.userName': 'Nombre del Usuario',
  'adsUserPushRecord.agentName': 'Nombre del Agente',
  'adsUserPushRecord.pushTime': 'Hora del Envío',
  'adsUserPushRecord.action': 'Acción',
  'adsUserPushRecord.viewParams': 'Parámetros',
  'adsUserPushRecord.retry': 'Reintentar',
  'adsUserPushRecord.paramDetail': 'Detalles de Parámetros',
  'adsUserPushRecord.paramDisclaimer': '*Los parámetros en esta página son solo de referencia, sujetos a la documentación de acoplamiento del proveedor de atribución*',
  'adsUserPushRecord.batchRetryTitle': 'Reintentar en Lote',
  'adsUserPushRecord.batchRetryConfirm': 'Los siguientes registros fallidos se reintentarán en este lote:',
  'adsUserPushRecord.batchRetryItem': '• Cuenta del Miembro: {account}, Evento: {event}, Hora del Envío: {time}',
  'adsUserPushRecord.batchRetryWarning': 'Confirme el reintento en lote, esta operación no se puede deshacer.',
  'adsUserPushRecord.confirm': 'Confirmar',
  'adsUserPushRecord.cancel': 'Cancelar',
  'adsUserPushRecord.retrySuccess': 'Reintento exitoso',
  'adsUserPushRecord.retryFailed': 'Reintento fallido',
  'adsUserPushRecord.batchRetrySuccess': 'Reintento en lote exitoso',
  'adsUserPushRecord.batchRetryFailed': 'Reintento en lote fallido',
  'adsUserPushRecord.fetchDataFailed': 'Error al obtener datos',
  'adsUserPushRecord.fetchAgentsFailed': 'Error al obtener lista de agentes',
  'adsUserPushRecord.fetchFailedRecordsFailed': 'Error al obtener registros fallidos',
  'adsUserPushRecord.pagination': 'Página {current} de {page}, Total {total} registros',
  'adsUserPushRecord.noData': 'Sin datos',
};
